export class ApiRoutes {
  static NODE = '/v1/node';
  static NODES = '/nodes';
  static EXTERNAL_CLIENTS = '/extclients';
  static HOSTS = '/hosts';
  static NETWORKS = '/networks';
  static DNS = '/dns';
  static LOGIN = '/users/adm/authenticate';
  static LOGIN_OAUTH = '/oauth/login';
  static SERVER_STATUS = '/server/status';
  static SERVER_CONFIG = '/server/getconfig';
  static ENROLLMENT_KEYS = '/v1/enrollment-keys';
  static USERS_ADMIN = '/users/adm';
  static USERS = '/users';
  static USER_GROUPS = '/usergroups';
  static METRICS = '/metrics';
  static METRICS_EXTERNAL_CLIENT = '/metrics-ext';
  static RESTART_TENANT = '/server/shutdown';
}
